<snl-navigation 
  [menuOptions]="menuOptions"
  [userOption]="userOption"
  [signOutOption]="signOutOption"
  [isCollapsed]="isCollapsed"
  (selectedOption) = 'selectedOption($event)'
  [environmentType]="environmentType"
  (navigationCollapse) = 'navigationCollapse($event)'
>
<div expanded >
  <img alt="stolt-tankers-logo" src="assets/img/stolt-tankers-logo.svg" />
</div>
<div collapsed class="collapsed">
  <img alt="logo_small" src="assets/logo_small.svg" />
</div>
<div top-container class="switch-button" *ngIf="fleets?.length > 1">
  <!-- <ng-select [(ngModel)]="selectedFleet" [searchable]="false" [clearable]="false"  (change)="switchFleet($event)">
    <ng-option *ngFor="let fleet of fleets" [value]="fleet">{{fleet}}</ng-option>
 </ng-select> -->
 
 <snl-dropdown
  [label]="'Fleet'"
  [buttonPrimary]="'Apply'"
  [buttonSecondary]="'Clear'"
  [options]="fleetOptions"
  [preSelectedItems]="defaultselectedFleet"
  [showAll]="true"
  [isInsideModal]="false"
  (selectedValues)="switchFleet($event.selectedRecords.name)"
></snl-dropdown>
</div>
</snl-navigation>
